export class Notification {
    constructor(message) {
        this.message = message;
    }
}
